export interface AndroidLanguage {
  code: string;
  name: string;
}

export const androidLanguages: AndroidLanguage[] = [
  { code: 'af-NA', name: 'Afrikaans (Namibia)' },
  { code: 'af-ZA', name: 'Afrikaans (South Africa)' },
  { code: 'agq-CM', name: 'Aghem (Cameroon)' },
  { code: 'ak-GH', name: 'Akan (Ghana)' },
  { code: 'am-ET', name: 'Amharic (Ethiopia)' },
  { code: 'ar-AE', name: 'Arabic (United Arab Emirates)' },
  {
    code: 'ar-AE-u-nu-arab',
    name: 'Arabic (United Arab Emirates, Arabic-Indic Digits)',
  },
  { code: 'ar-BH', name: 'Arabic (Bahrain)' },
  { code: 'ar-BH-u-nu-latn', name: 'Arabic (Bahrain, Western Digits)' },
  { code: 'ar-DJ', name: 'Arabic (Djibouti)' },
  { code: 'ar-DJ-u-nu-latn', name: 'Arabic (Djibouti, Western Digits)' },
  { code: 'ar-DZ', name: 'Arabic (Algeria)' },
  { code: 'ar-DZ-u-nu-arab', name: 'Arabic (Algeria, Arabic-Indic Digits)' },
  { code: 'ar-EG', name: 'Arabic (Egypt)' },
  { code: 'ar-EG-u-nu-latn', name: 'Arabic (Egypt, Western Digits)' },
  { code: 'ar-EH', name: 'Arabic (Western Sahara)' },
  {
    code: 'ar-EH-u-nu-arab',
    name: 'Arabic (Western Sahara, Arabic-Indic Digits)',
  },
  { code: 'ar-ER', name: 'Arabic (Eritrea)' },
  { code: 'ar-ER-u-nu-latn', name: 'Arabic (Eritrea, Western Digits)' },
  { code: 'ar-IL', name: 'Arabic (Israel)' },
  { code: 'ar-IL-u-nu-latn', name: 'Arabic (Israel, Western Digits)' },
  { code: 'ar-IQ', name: 'Arabic (Iraq)' },
  { code: 'ar-IQ-u-nu-latn', name: 'Arabic (Iraq, Western Digits)' },
  { code: 'ar-JO', name: 'Arabic (Jordan)' },
  { code: 'ar-JO-u-nu-latn', name: 'Arabic (Jordan, Western Digits)' },
  { code: 'ar-KM', name: 'Arabic (Comoros)' },
  { code: 'ar-KM-u-nu-latn', name: 'Arabic (Comoros, Western Digits)' },
  { code: 'ar-KW', name: 'Arabic (Kuwait)' },
  { code: 'ar-KW-u-nu-latn', name: 'Arabic (Kuwait, Western Digits)' },
  { code: 'ar-LB', name: 'Arabic (Lebanon)' },
  { code: 'ar-LB-u-nu-latn', name: 'Arabic (Lebanon, Western Digits)' },
  { code: 'ar-LY', name: 'Arabic (Libya)' },
  { code: 'ar-LY-u-nu-arab', name: 'Arabic (Libya, Arabic-Indic Digits)' },
  { code: 'ar-MA', name: 'Arabic (Morocco)' },
  { code: 'ar-MA-u-nu-arab', name: 'Arabic (Morocco, Arabic-Indic Digits)' },
  { code: 'ar-MR', name: 'Arabic (Mauritania)' },
  { code: 'ar-MR-u-nu-latn', name: 'Arabic (Mauritania, Western Digits)' },
  { code: 'ar-OM', name: 'Arabic (Oman)' },
  { code: 'ar-OM-u-nu-latn', name: 'Arabic (Oman, Western Digits)' },
  { code: 'ar-PS', name: 'Arabic (Palestine)' },
  { code: 'ar-PS-u-nu-latn', name: 'Arabic (Palestine, Western Digits)' },
  { code: 'ar-QA', name: 'Arabic (Qatar)' },
  { code: 'ar-QA-u-nu-latn', name: 'Arabic (Qatar, Western Digits)' },
  { code: 'ar-SA', name: 'Arabic (Saudi Arabia)' },
  { code: 'ar-SA-u-nu-latn', name: 'Arabic (Saudi Arabia, Western Digits)' },
  { code: 'ar-SD', name: 'Arabic (Sudan)' },
  { code: 'ar-SD-u-nu-latn', name: 'Arabic (Sudan, Western Digits)' },
  { code: 'ar-SO', name: 'Arabic (Somalia)' },
  { code: 'ar-SO-u-nu-latn', name: 'Arabic (Somalia, Western Digits)' },
  { code: 'ar-SS', name: 'Arabic (South Sudan)' },
  { code: 'ar-SS-u-nu-latn', name: 'Arabic (South Sudan, Western Digits)' },
  { code: 'ar-SY', name: 'Arabic (Syria)' },
  { code: 'ar-SY-u-nu-latn', name: 'Arabic (Syria, Western Digits)' },
  { code: 'ar-TD', name: 'Arabic (Chad)' },
  { code: 'ar-TD-u-nu-latn', name: 'Arabic (Chad, Western Digits)' },
  { code: 'ar-TN', name: 'Arabic (Tunisia)' },
  { code: 'ar-TN-u-nu-arab', name: 'Arabic (Tunisia, Arabic-Indic Digits)' },
  { code: 'ar-XB', name: 'Arabic (Pseudo-Bidi)' },
  { code: 'ar-YE', name: 'Arabic (Yemen)' },
  { code: 'ar-YE-u-nu-latn', name: 'Arabic (Yemen, Western Digits)' },
  { code: 'as-IN', name: 'Assamese (India)' },
  { code: 'as-IN-u-nu-latn', name: 'Assamese (India, Western Digits)' },
  { code: 'asa-TZ', name: 'Asu (Tanzania)' },
  { code: 'ast-ES', name: 'Asturian (Spain)' },
  { code: 'az-Cyrl-AZ', name: 'Azerbaijani (Cyrillic, Azerbaijan)' },
  { code: 'az-Latn-AZ', name: 'Azerbaijani (Latin, Azerbaijan)' },
  { code: 'bas-CM', name: 'Basaa (Cameroon)' },
  { code: 'be-BY', name: 'Belarusian (Belarus)' },
  { code: 'bem-ZM', name: 'Bemba (Zambia)' },
  { code: 'bez-TZ', name: 'Bena (Tanzania)' },
  { code: 'bg-BG', name: 'Bulgarian (Bulgaria)' },
  { code: 'bgc-IN', name: 'Haryanvi (India)' },
  { code: 'bgc-IN-u-nu-latn', name: 'Haryanvi (India, Western Digits)' },
  { code: 'bho-IN', name: 'Bhojpuri (India)' },
  { code: 'bho-IN-u-nu-latn', name: 'Bhojpuri (India, Western Digits)' },
  { code: 'blo-BJ', name: 'Anii (Benin)' },
  { code: 'bm-ML', name: 'Bambara (Mali)' },
  { code: 'bn-BD', name: 'Bangla (Bangladesh)' },
  { code: 'bn-BD-u-nu-latn', name: 'Bangla (Bangladesh, Western Digits)' },
  { code: 'bn-IN', name: 'Bangla (India)' },
  { code: 'bn-IN-u-nu-latn', name: 'Bangla (India, Western Digits)' },
  { code: 'bo-CN', name: 'Tibetan (China)' },
  { code: 'bo-IN', name: 'Tibetan (India)' },
  { code: 'br-FR', name: 'Breton (France)' },
  { code: 'brx-IN', name: 'Bodo (India)' },
  { code: 'bs-Cyrl-BA', name: 'Bosnian (Cyrillic, Bosnia & Herzegovina)' },
  { code: 'bs-Latn-BA', name: 'Bosnian (Latin, Bosnia & Herzegovina)' },
  { code: 'ca-AD', name: 'Catalan (Andorra)' },
  { code: 'ca-ES', name: 'Catalan (Spain)' },
  { code: 'ca-FR', name: 'Catalan (France)' },
  { code: 'ca-IT', name: 'Catalan (Italy)' },
  { code: 'ce-RU', name: 'Chechen (Russia)' },
  { code: 'ceb-PH', name: 'Cebuano (Philippines)' },
  { code: 'cgg-UG', name: 'Chiga (Uganda)' },
  { code: 'chr-US', name: 'Cherokee (United States)' },
  { code: 'cs-CZ', name: 'Czech (Czechia)' },
  { code: 'csw-CA', name: 'Swampy Cree (Canada)' },
  { code: 'cv-RU', name: 'Chuvash (Russia)' },
  { code: 'cy-GB', name: 'Welsh (United Kingdom)' },
  { code: 'da-DK', name: 'Danish (Denmark)' },
  { code: 'da-GL', name: 'Danish (Greenland)' },
  { code: 'dav-KE', name: 'Taita (Kenya)' },
  { code: 'de-AT', name: 'German (Austria)' },
  { code: 'de-BE', name: 'German (Belgium)' },
  { code: 'de-CH', name: 'German (Switzerland)' },
  { code: 'de-DE', name: 'German (Germany)' },
  { code: 'de-IT', name: 'German (Italy)' },
  { code: 'de-LI', name: 'German (Liechtenstein)' },
  { code: 'de-LU', name: 'German (Luxembourg)' },
  { code: 'dje-NE', name: 'Zarma (Niger)' },
  { code: 'doi-IN', name: 'Dogri (India)' },
  { code: 'dsb-DE', name: 'Lower Sorbian (Germany)' },
  { code: 'dua-CM', name: 'Duala (Cameroon)' },
  { code: 'dyo-SN', name: 'Jola-Fonyi (Senegal)' },
  { code: 'dz-BT', name: 'Dzongkha (Bhutan)' },
  { code: 'dz-BT-u-nu-latn', name: 'Dzongkha (Bhutan, Western Digits)' },
  { code: 'ebu-KE', name: 'Embu (Kenya)' },
  { code: 'ee-GH', name: 'Ewe (Ghana)' },
  { code: 'ee-TG', name: 'Ewe (Togo)' },
  { code: 'el-CY', name: 'Greek (Cyprus)' },
  { code: 'el-GR', name: 'Greek (Greece)' },
  { code: 'en-AE', name: 'English (United Arab Emirates)' },
  { code: 'en-AG', name: 'English (Antigua & Barbuda)' },
  { code: 'en-AI', name: 'English (Anguilla)' },
  { code: 'en-AS', name: 'English (American Samoa)' },
  { code: 'en-AT', name: 'English (Austria)' },
  { code: 'en-AU', name: 'English (Australia)' },
  { code: 'en-BB', name: 'English (Barbados)' },
  { code: 'en-BE', name: 'English (Belgium)' },
  { code: 'en-BI', name: 'English (Burundi)' },
  { code: 'en-BM', name: 'English (Bermuda)' },
  { code: 'en-BS', name: 'English (Bahamas)' },
  { code: 'en-BW', name: 'English (Botswana)' },
  { code: 'en-BZ', name: 'English (Belize)' },
  { code: 'en-CA', name: 'English (Canada)' },
  { code: 'en-CC', name: 'English (Cocos (Keeling) Islands)' },
  { code: 'en-CH', name: 'English (Switzerland)' },
  { code: 'en-CK', name: 'English (Cook Islands)' },
  { code: 'en-CM', name: 'English (Cameroon)' },
  { code: 'en-CX', name: 'English (Christmas Island)' },
  { code: 'en-CY', name: 'English (Cyprus)' },
  { code: 'en-CZ', name: 'English (Czechia)' },
  { code: 'en-DE', name: 'English (Germany)' },
  { code: 'en-DG', name: 'English (Diego Garcia)' },
  { code: 'en-DK', name: 'English (Denmark)' },
  { code: 'en-DM', name: 'English (Dominica)' },
  { code: 'en-ER', name: 'English (Eritrea)' },
  { code: 'en-ES', name: 'English (Spain)' },
  { code: 'en-FI', name: 'English (Finland)' },
  { code: 'en-FJ', name: 'English (Fiji)' },
  { code: 'en-FK', name: 'English (Falkland Islands (Islas Malvinas))' },
  { code: 'en-FM', name: 'English (Micronesia)' },
  { code: 'en-FR', name: 'English (France)' },
  { code: 'en-GB', name: 'English (United Kingdom)' },
  { code: 'en-GD', name: 'English (Grenada)' },
  { code: 'en-GG', name: 'English (Guernsey)' },
  { code: 'en-GH', name: 'English (Ghana)' },
  { code: 'en-GI', name: 'English (Gibraltar)' },
  { code: 'en-GM', name: 'English (Gambia)' },
  { code: 'en-GU', name: 'English (Guam)' },
  { code: 'en-GY', name: 'English (Guyana)' },
  { code: 'en-HK', name: 'English (Hong Kong)' },
  { code: 'en-HU', name: 'English (Hungary)' },
  { code: 'en-ID', name: 'English (Indonesia)' },
  { code: 'en-IE', name: 'English (Ireland)' },
  { code: 'en-IL', name: 'English (Israel)' },
  { code: 'en-IM', name: 'English (Isle of Man)' },
  { code: 'en-IN', name: 'English (India)' },
  { code: 'en-IO', name: 'English (British Indian Ocean Territory)' },
  { code: 'en-IT', name: 'English (Italy)' },
  { code: 'en-JE', name: 'English (Jersey)' },
  { code: 'en-JM', name: 'English (Jamaica)' },
  { code: 'en-KE', name: 'English (Kenya)' },
  { code: 'en-KI', name: 'English (Kiribati)' },
  { code: 'en-KN', name: 'English (St. Kitts & Nevis)' },
  { code: 'en-KY', name: 'English (Cayman Islands)' },
  { code: 'en-LC', name: 'English (St. Lucia)' },
  { code: 'en-LR', name: 'English (Liberia)' },
  { code: 'en-LS', name: 'English (Lesotho)' },
  { code: 'en-MG', name: 'English (Madagascar)' },
  { code: 'en-MH', name: 'English (Marshall Islands)' },
  { code: 'en-MO', name: 'English (Macao)' },
  { code: 'en-MP', name: 'English (Northern Mariana Islands)' },
  { code: 'en-MS', name: 'English (Montserrat)' },
  { code: 'en-MT', name: 'English (Malta)' },
  { code: 'en-MU', name: 'English (Mauritius)' },
  { code: 'en-MV', name: 'English (Maldives)' },
  { code: 'en-MW', name: 'English (Malawi)' },
  { code: 'en-MY', name: 'English (Malaysia)' },
  { code: 'en-NA', name: 'English (Namibia)' },
  { code: 'en-NF', name: 'English (Norfolk Island)' },
  { code: 'en-NG', name: 'English (Nigeria)' },
  { code: 'en-NL', name: 'English (Netherlands)' },
  { code: 'en-NO', name: 'English (Norway)' },
  { code: 'en-NR', name: 'English (Nauru)' },
  { code: 'en-NU', name: 'English (Niue)' },
  { code: 'en-NZ', name: 'English (New Zealand)' },
  { code: 'en-PG', name: 'English (Papua New Guinea)' },
  { code: 'en-PH', name: 'English (Philippines)' },
  { code: 'en-PK', name: 'English (Pakistan)' },
  { code: 'en-PL', name: 'English (Poland)' },
  { code: 'en-PN', name: 'English (Pitcairn Islands)' },
  { code: 'en-PR', name: 'English (Puerto Rico)' },
  { code: 'en-PT', name: 'English (Portugal)' },
  { code: 'en-PW', name: 'English (Palau)' },
  { code: 'en-RO', name: 'English (Romania)' },
  { code: 'en-RW', name: 'English (Rwanda)' },
  { code: 'en-SB', name: 'English (Solomon Islands)' },
  { code: 'en-SC', name: 'English (Seychelles)' },
  { code: 'en-SD', name: 'English (Sudan)' },
  { code: 'en-SE', name: 'English (Sweden)' },
  { code: 'en-SG', name: 'English (Singapore)' },
  { code: 'en-SH', name: 'English (St. Helena)' },
  { code: 'en-SI', name: 'English (Slovenia)' },
  { code: 'en-SK', name: 'English (Slovakia)' },
  { code: 'en-SL', name: 'English (Sierra Leone)' },
  { code: 'en-SS', name: 'English (South Sudan)' },
  { code: 'en-SX', name: 'English (Sint Maarten)' },
  { code: 'en-SZ', name: 'English (Eswatini)' },
  { code: 'en-TC', name: 'English (Turks & Caicos Islands)' },
  { code: 'en-TK', name: 'English (Tokelau)' },
  { code: 'en-TO', name: 'English (Tonga)' },
  { code: 'en-TT', name: 'English (Trinidad & Tobago)' },
  { code: 'en-TV', name: 'English (Tuvalu)' },
  { code: 'en-TZ', name: 'English (Tanzania)' },
  { code: 'en-UG', name: 'English (Uganda)' },
  { code: 'en-UM', name: 'English (U.S. Outlying Islands)' },
  { code: 'en-US', name: 'English (United States)' },
  { code: 'en-VC', name: 'English (St. Vincent & Grenadines)' },
  { code: 'en-VG', name: 'English (British Virgin Islands)' },
  { code: 'en-VI', name: 'English (U.S. Virgin Islands)' },
  { code: 'en-VU', name: 'English (Vanuatu)' },
  { code: 'en-WS', name: 'English (Samoa)' },
  { code: 'en-XA', name: 'English (Pseudo-Accents)' },
  { code: 'en-ZA', name: 'English (South Africa)' },
  { code: 'en-ZM', name: 'English (Zambia)' },
  { code: 'en-ZW', name: 'English (Zimbabwe)' },
  { code: 'eo-001', name: 'Esperanto (world)' },
  { code: 'es-AR', name: 'Spanish (Argentina)' },
  { code: 'es-BO', name: 'Spanish (Bolivia)' },
  { code: 'es-BR', name: 'Spanish (Brazil)' },
  { code: 'es-BZ', name: 'Spanish (Belize)' },
  { code: 'es-CL', name: 'Spanish (Chile)' },
  { code: 'es-CO', name: 'Spanish (Colombia)' },
  { code: 'es-CR', name: 'Spanish (Costa Rica)' },
  { code: 'es-CU', name: 'Spanish (Cuba)' },
  { code: 'es-DO', name: 'Spanish (Dominican Republic)' },
  { code: 'es-EA', name: 'Spanish (Ceuta & Melilla)' },
  { code: 'es-EC', name: 'Spanish (Ecuador)' },
  { code: 'es-ES', name: 'Spanish (Spain)' },
  { code: 'es-GQ', name: 'Spanish (Equatorial Guinea)' },
  { code: 'es-GT', name: 'Spanish (Guatemala)' },
  { code: 'es-HN', name: 'Spanish (Honduras)' },
  { code: 'es-IC', name: 'Spanish (Canary Islands)' },
  { code: 'es-MX', name: 'Spanish (Mexico)' },
  { code: 'es-NI', name: 'Spanish (Nicaragua)' },
  { code: 'es-PA', name: 'Spanish (Panama)' },
  { code: 'es-PE', name: 'Spanish (Peru)' },
  { code: 'es-PH', name: 'Spanish (Philippines)' },
  { code: 'es-PR', name: 'Spanish (Puerto Rico)' },
  { code: 'es-PY', name: 'Spanish (Paraguay)' },
  { code: 'es-SV', name: 'Spanish (El Salvador)' },
  { code: 'es-US', name: 'Spanish (United States)' },
  { code: 'es-UY', name: 'Spanish (Uruguay)' },
  { code: 'es-VE', name: 'Spanish (Venezuela)' },
  { code: 'et-EE', name: 'Estonian (Estonia)' },
  { code: 'eu-ES', name: 'Basque (Spain)' },
  { code: 'ewo-CM', name: 'Ewondo (Cameroon)' },
  { code: 'fa-AF', name: 'Persian (Afghanistan)' },
  { code: 'fa-AF-u-nu-latn', name: 'Persian (Afghanistan, Western Digits)' },
  { code: 'fa-IR', name: 'Persian (Iran)' },
  { code: 'fa-IR-u-nu-latn', name: 'Persian (Iran, Western Digits)' },
  { code: 'ff-Adlm-BF', name: 'Fula (Adlam, Burkina Faso)' },
  {
    code: 'ff-Adlm-BF-u-nu-latn',
    name: 'Fula (Adlam, Burkina Faso, Western Digits)',
  },
  { code: 'ff-Adlm-CM', name: 'Fula (Adlam, Cameroon)' },
  {
    code: 'ff-Adlm-CM-u-nu-latn',
    name: 'Fula (Adlam, Cameroon, Western Digits)',
  },
  { code: 'ff-Adlm-GH', name: 'Fula (Adlam, Ghana)' },
  { code: 'ff-Adlm-GH-u-nu-latn', name: 'Fula (Adlam, Ghana, Western Digits)' },
  { code: 'ff-Adlm-GM', name: 'Fula (Adlam, Gambia)' },
  {
    code: 'ff-Adlm-GM-u-nu-latn',
    name: 'Fula (Adlam, Gambia, Western Digits)',
  },
  { code: 'ff-Adlm-GN', name: 'Fula (Adlam, Guinea)' },
  {
    code: 'ff-Adlm-GN-u-nu-latn',
    name: 'Fula (Adlam, Guinea, Western Digits)',
  },
  { code: 'ff-Adlm-GW', name: 'Fula (Adlam, Guinea-Bissau)' },
  {
    code: 'ff-Adlm-GW-u-nu-latn',
    name: 'Fula (Adlam, Guinea-Bissau, Western Digits)',
  },
  { code: 'ff-Adlm-LR', name: 'Fula (Adlam, Liberia)' },
  {
    code: 'ff-Adlm-LR-u-nu-latn',
    name: 'Fula (Adlam, Liberia, Western Digits)',
  },
  { code: 'ff-Adlm-MR', name: 'Fula (Adlam, Mauritania)' },
  {
    code: 'ff-Adlm-MR-u-nu-latn',
    name: 'Fula (Adlam, Mauritania, Western Digits)',
  },
  { code: 'ff-Adlm-NE', name: 'Fula (Adlam, Niger)' },
  { code: 'ff-Adlm-NE-u-nu-latn', name: 'Fula (Adlam, Niger, Western Digits)' },
  { code: 'ff-Adlm-NG', name: 'Fula (Adlam, Nigeria)' },
  {
    code: 'ff-Adlm-NG-u-nu-latn',
    name: 'Fula (Adlam, Nigeria, Western Digits)',
  },
  { code: 'ff-Adlm-SL', name: 'Fula (Adlam, Sierra Leone)' },
  {
    code: 'ff-Adlm-SL-u-nu-latn',
    name: 'Fula (Adlam, Sierra Leone, Western Digits)',
  },
  { code: 'ff-Adlm-SN', name: 'Fula (Adlam, Senegal)' },
  {
    code: 'ff-Adlm-SN-u-nu-latn',
    name: 'Fula (Adlam, Senegal, Western Digits)',
  },
  { code: 'ff-Latn-BF', name: 'Fula (Latin, Burkina Faso)' },
  { code: 'ff-Latn-CM', name: 'Fula (Latin, Cameroon)' },
  { code: 'ff-Latn-GH', name: 'Fula (Latin, Ghana)' },
  { code: 'ff-Latn-GM', name: 'Fula (Latin, Gambia)' },
  { code: 'ff-Latn-GN', name: 'Fula (Latin, Guinea)' },
  { code: 'ff-Latn-GW', name: 'Fula (Latin, Guinea-Bissau)' },
  { code: 'ff-Latn-LR', name: 'Fula (Latin, Liberia)' },
  { code: 'ff-Latn-MR', name: 'Fula (Latin, Mauritania)' },
  { code: 'ff-Latn-NE', name: 'Fula (Latin, Niger)' },
  { code: 'ff-Latn-NG', name: 'Fula (Latin, Nigeria)' },
  { code: 'ff-Latn-SL', name: 'Fula (Latin, Sierra Leone)' },
  { code: 'ff-Latn-SN', name: 'Fula (Latin, Senegal)' },
  { code: 'fi-FI', name: 'Finnish (Finland)' },
  { code: 'fil-PH', name: 'Filipino (Philippines)' },
  { code: 'fo-DK', name: 'Faroese (Denmark)' },
  { code: 'fo-FO', name: 'Faroese (Faroe Islands)' },
  { code: 'fr-BE', name: 'French (Belgium)' },
  { code: 'fr-BF', name: 'French (Burkina Faso)' },
  { code: 'fr-BI', name: 'French (Burundi)' },
  { code: 'fr-BJ', name: 'French (Benin)' },
  { code: 'fr-BL', name: 'French (St. Barthélemy)' },
  { code: 'fr-CA', name: 'French (Canada)' },
  { code: 'fr-CD', name: 'French (Congo - Kinshasa)' },
  { code: 'fr-CF', name: 'French (Central African Republic)' },
  { code: 'fr-CG', name: 'French (Congo - Brazzaville)' },
  { code: 'fr-CH', name: 'French (Switzerland)' },
  { code: 'fr-CI', name: "French (Côte d'Ivoire)" },
  { code: 'fr-CM', name: 'French (Cameroon)' },
  { code: 'fr-DJ', name: 'French (Djibouti)' },
  { code: 'fr-DZ', name: 'French (Algeria)' },
  { code: 'fr-FR', name: 'French (France)' },
  { code: 'fr-GA', name: 'French (Gabon)' },
  { code: 'fr-GF', name: 'French (French Guiana)' },
  { code: 'fr-GN', name: 'French (Guinea)' },
  { code: 'fr-GP', name: 'French (Guadeloupe)' },
  { code: 'fr-GQ', name: 'French (Equatorial Guinea)' },
  { code: 'fr-HT', name: 'French (Haiti)' },
  { code: 'fr-KM', name: 'French (Comoros)' },
  { code: 'fr-LU', name: 'French (Luxembourg)' },
  { code: 'fr-MA', name: 'French (Morocco)' },
  { code: 'fr-MC', name: 'French (Monaco)' },
  { code: 'fr-MF', name: 'French (St. Martin)' },
  { code: 'fr-MG', name: 'French (Madagascar)' },
  { code: 'fr-ML', name: 'French (Mali)' },
  { code: 'fr-MQ', name: 'French (Martinique)' },
  { code: 'fr-MR', name: 'French (Mauritania)' },
  { code: 'fr-MU', name: 'French (Mauritius)' },
  { code: 'fr-NC', name: 'French (New Caledonia)' },
  { code: 'fr-NE', name: 'French (Niger)' },
  { code: 'fr-PF', name: 'French (French Polynesia)' },
  { code: 'fr-PM', name: 'French (St. Pierre & Miquelon)' },
  { code: 'fr-RE', name: 'French (Réunion)' },
  { code: 'fr-RW', name: 'French (Rwanda)' },
  { code: 'fr-SC', name: 'French (Seychelles)' },
  { code: 'fr-SN', name: 'French (Senegal)' },
  { code: 'fr-SY', name: 'French (Syria)' },
  { code: 'fr-TD', name: 'French (Chad)' },
  { code: 'fr-TG', name: 'French (Togo)' },
  { code: 'fr-TN', name: 'French (Tunisia)' },
  { code: 'fr-VU', name: 'French (Vanuatu)' },
  { code: 'fr-WF', name: 'French (Wallis & Futuna)' },
  { code: 'fr-YT', name: 'French (Mayotte)' },
  { code: 'fur-IT', name: 'Friulian (Italy)' },
  { code: 'fy-NL', name: 'Western Frisian (Netherlands)' },
  { code: 'ga-GB', name: 'Irish (United Kingdom)' },
  { code: 'ga-IE', name: 'Irish (Ireland)' },
  { code: 'gd-GB', name: 'Scottish Gaelic (United Kingdom)' },
  { code: 'gl-ES', name: 'Galician (Spain)' },
  { code: 'gsw-CH', name: 'Swiss German (Switzerland)' },
  { code: 'gsw-FR', name: 'Swiss German (France)' },
  { code: 'gsw-LI', name: 'Swiss German (Liechtenstein)' },
  { code: 'gu-IN', name: 'Gujarati (India)' },
  { code: 'guz-KE', name: 'Gusii (Kenya)' },
  { code: 'gv-IM', name: 'Manx (Isle of Man)' },
  { code: 'ha-GH', name: 'Hausa (Ghana)' },
  { code: 'ha-NE', name: 'Hausa (Niger)' },
  { code: 'ha-NG', name: 'Hausa (Nigeria)' },
  { code: 'haw-US', name: 'Hawaiian (United States)' },
  { code: 'hi-IN', name: 'Hindi (India)' },
  { code: 'hi-Latn-IN', name: 'Hindi (Latin, India)' },
  { code: 'hr-BA', name: 'Croatian (Bosnia & Herzegovina)' },
  { code: 'hr-HR', name: 'Croatian (Croatia)' },
  { code: 'hsb-DE', name: 'Upper Sorbian (Germany)' },
  { code: 'hu-HU', name: 'Hungarian (Hungary)' },
  { code: 'hy-AM', name: 'Armenian (Armenia)' },
  { code: 'ia-001', name: 'Interlingua (world)' },
  { code: 'ie-EE', name: 'Interlingue (Estonia)' },
  { code: 'ig-NG', name: 'Igbo (Nigeria)' },
  { code: 'ii-CN', name: 'Sichuan Yi (China)' },
  { code: 'in-ID', name: 'Indonesian (Indonesia)' },
  { code: 'is-IS', name: 'Icelandic (Iceland)' },
  { code: 'it-CH', name: 'Italian (Switzerland)' },
  { code: 'it-IT', name: 'Italian (Italy)' },
  { code: 'it-SM', name: 'Italian (San Marino)' },
  { code: 'it-VA', name: 'Italian (Vatican City)' },
  { code: 'iw-IL', name: 'Hebrew (Israel)' },
  { code: 'ja-JP', name: 'Japanese (Japan)' },
  { code: 'jgo-CM', name: 'Ngomba (Cameroon)' },
  { code: 'jmc-TZ', name: 'Machame (Tanzania)' },
  { code: 'jv-ID', name: 'Javanese (Indonesia)' },
  { code: 'ka-GE', name: 'Georgian (Georgia)' },
  { code: 'kab-DZ', name: 'Kabyle (Algeria)' },
  { code: 'kam-KE', name: 'Kamba (Kenya)' },
  { code: 'kde-TZ', name: 'Makonde (Tanzania)' },
  { code: 'kea-CV', name: 'Kabuverdianu (Cape Verde)' },
  { code: 'kgp-BR', name: 'Kaingang (Brazil)' },
  { code: 'khq-ML', name: 'Koyra Chiini (Mali)' },
  { code: 'ki-KE', name: 'Kikuyu (Kenya)' },
  { code: 'kk-KZ', name: 'Kazakh (Kazakhstan)' },
  { code: 'kkj-CM', name: 'Kako (Cameroon)' },
  { code: 'kl-GL', name: 'Kalaallisut (Greenland)' },
  { code: 'kln-KE', name: 'Kalenjin (Kenya)' },
  { code: 'km-KH', name: 'Khmer (Cambodia)' },
  { code: 'kn-IN', name: 'Kannada (India)' },
  { code: 'ko-CN', name: 'Korean (China)' },
  { code: 'ko-KP', name: 'Korean (North Korea)' },
  { code: 'ko-KR', name: 'Korean (South Korea)' },
  { code: 'kok-IN', name: 'Konkani (India)' },
  { code: 'ks-Arab-IN', name: 'Kashmiri (Arabic, India)' },
  {
    code: 'ks-Arab-IN-u-nu-latn',
    name: 'Kashmiri (Arabic, India, Western Digits)',
  },
  { code: 'ks-Deva-IN', name: 'Kashmiri (Devanagari, India)' },
  { code: 'ksb-TZ', name: 'Shambala (Tanzania)' },
  { code: 'ksf-CM', name: 'Bafia (Cameroon)' },
  { code: 'ksh-DE', name: 'Colognian (Germany)' },
  { code: 'ku-TR', name: 'Kurdish (Türkiye)' },
  { code: 'kw-GB', name: 'Cornish (United Kingdom)' },
  { code: 'kxv-Deva-IN', name: 'Kuvi (Devanagari, India)' },
  { code: 'kxv-Latn-IN', name: 'Kuvi (Latin, India)' },
  { code: 'kxv-Orya-IN', name: 'Kuvi (Odia, India)' },
  { code: 'kxv-Telu-IN', name: 'Kuvi (Telugu, India)' },
  { code: 'ky-KG', name: 'Kyrgyz (Kyrgyzstan)' },
  { code: 'lag-TZ', name: 'Langi (Tanzania)' },
  { code: 'lb-LU', name: 'Luxembourgish (Luxembourg)' },
  { code: 'lg-UG', name: 'Ganda (Uganda)' },
  { code: 'lij-IT', name: 'Ligurian (Italy)' },
  { code: 'lkt-US', name: 'Lakota (United States)' },
  { code: 'lmo-IT', name: 'Lombard (Italy)' },
  { code: 'ln-AO', name: 'Lingala (Angola)' },
  { code: 'ln-CD', name: 'Lingala (Congo - Kinshasa)' },
  { code: 'ln-CF', name: 'Lingala (Central African Republic)' },
  { code: 'ln-CG', name: 'Lingala (Congo - Brazzaville)' },
  { code: 'lo-LA', name: 'Lao (Laos)' },
  { code: 'lt-LT', name: 'Lithuanian (Lithuania)' },
  { code: 'lu-CD', name: 'Luba-Katanga (Congo - Kinshasa)' },
  { code: 'luo-KE', name: 'Luo (Kenya)' },
  { code: 'luy-KE', name: 'Luyia (Kenya)' },
  { code: 'lv-LV', name: 'Latvian (Latvia)' },
  { code: 'mai-IN', name: 'Maithili (India)' },
  { code: 'mas-KE', name: 'Masai (Kenya)' },
  { code: 'mas-TZ', name: 'Masai (Tanzania)' },
  { code: 'mer-KE', name: 'Meru (Kenya)' },
  { code: 'mfe-MU', name: 'Morisyen (Mauritius)' },
  { code: 'mg-MG', name: 'Malagasy (Madagascar)' },
  { code: 'mgh-MZ', name: 'Makhuwa-Meetto (Mozambique)' },
  { code: 'mgo-CM', name: 'Metaʼ (Cameroon)' },
  { code: 'mi-NZ', name: 'Māori (New Zealand)' },
  { code: 'mk-MK', name: 'Macedonian (North Macedonia)' },
  { code: 'ml-IN', name: 'Malayalam (India)' },
  { code: 'mn-MN', name: 'Mongolian (Mongolia)' },
  { code: 'mni-IN', name: 'Manipuri (India)' },
  { code: 'mni-IN-u-nu-latn', name: 'Manipuri (India, Western Digits)' },
  { code: 'mr-IN', name: 'Marathi (India)' },
  { code: 'mr-IN-u-nu-latn', name: 'Marathi (India, Western Digits)' },
  { code: 'ms-BN', name: 'Malay (Brunei)' },
  { code: 'ms-ID', name: 'Malay (Indonesia)' },
  { code: 'ms-MY', name: 'Malay (Malaysia)' },
  { code: 'ms-SG', name: 'Malay (Singapore)' },
  { code: 'mt-MT', name: 'Maltese (Malta)' },
  { code: 'my-MM', name: 'Burmese (Myanmar (Burma))' },
  {
    code: 'my-MM-u-nu-latn',
    name: 'Burmese (Myanmar (Burma), Western Digits)',
  },
  { code: 'mzn-IR', name: 'Mazanderani (Iran)' },
  { code: 'mzn-IR-u-nu-latn', name: 'Mazanderani (Iran, Western Digits)' },
  { code: 'naq-NA', name: 'Nama (Namibia)' },
  { code: 'nb-NO', name: 'Norwegian Bokmål (Norway)' },
  { code: 'nb-SJ', name: 'Norwegian Bokmål (Svalbard & Jan Mayen)' },
  { code: 'nd-ZW', name: 'North Ndebele (Zimbabwe)' },
  { code: 'nds-DE', name: 'Low German (Germany)' },
  { code: 'nds-NL', name: 'Low German (Netherlands)' },
  { code: 'ne-IN', name: 'Nepali (India)' },
  { code: 'ne-IN-u-nu-latn', name: 'Nepali (India, Western Digits)' },
  { code: 'ne-NP', name: 'Nepali (Nepal)' },
  { code: 'ne-NP-u-nu-latn', name: 'Nepali (Nepal, Western Digits)' },
  { code: 'nl-AW', name: 'Dutch (Aruba)' },
  { code: 'nl-BE', name: 'Dutch (Belgium)' },
  { code: 'nl-BQ', name: 'Dutch (Caribbean Netherlands)' },
  { code: 'nl-CW', name: 'Dutch (Curaçao)' },
  { code: 'nl-NL', name: 'Dutch (Netherlands)' },
  { code: 'nl-SR', name: 'Dutch (Suriname)' },
  { code: 'nl-SX', name: 'Dutch (Sint Maarten)' },
  { code: 'nn-NO', name: 'Norwegian Nynorsk (Norway)' },
  { code: 'nnh-CM', name: 'Ngiemboon (Cameroon)' },
  { code: 'nqo-GN', name: "N'Ko (Guinea)" },
  { code: 'nqo-GN-u-nu-latn', name: "N'Ko (Guinea, Western Digits)" },
  { code: 'nus-SS', name: 'Nuer (South Sudan)' },
  { code: 'nyn-UG', name: 'Nyankole (Uganda)' },
  { code: 'oc-ES', name: 'Occitan (Spain)' },
  { code: 'oc-FR', name: 'Occitan (France)' },
  { code: 'om-ET', name: 'Oromo (Ethiopia)' },
  { code: 'om-KE', name: 'Oromo (Kenya)' },
  { code: 'or-IN', name: 'Odia (India)' },
  { code: 'os-GE', name: 'Ossetic (Georgia)' },
  { code: 'os-RU', name: 'Ossetic (Russia)' },
  { code: 'pa-Arab-PK', name: 'Punjabi (Arabic, Pakistan)' },
  {
    code: 'pa-Arab-PK-u-nu-latn',
    name: 'Punjabi (Arabic, Pakistan, Western Digits)',
  },
  { code: 'pa-Guru-IN', name: 'Punjabi (Gurmukhi, India)' },
  { code: 'pcm-NG', name: 'Nigerian Pidgin (Nigeria)' },
  { code: 'pl-PL', name: 'Polish (Poland)' },
  { code: 'prg-PL', name: 'Prussian (Poland)' },
  { code: 'ps-AF', name: 'Pashto (Afghanistan)' },
  { code: 'ps-AF-u-nu-latn', name: 'Pashto (Afghanistan, Western Digits)' },
  { code: 'ps-PK', name: 'Pashto (Pakistan)' },
  { code: 'ps-PK-u-nu-latn', name: 'Pashto (Pakistan, Western Digits)' },
  { code: 'pt-AO', name: 'Portuguese (Angola)' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)' },
  { code: 'pt-CH', name: 'Portuguese (Switzerland)' },
  { code: 'pt-CV', name: 'Portuguese (Cape Verde)' },
  { code: 'pt-GQ', name: 'Portuguese (Equatorial Guinea)' },
  { code: 'pt-GW', name: 'Portuguese (Guinea-Bissau)' },
  { code: 'pt-LU', name: 'Portuguese (Luxembourg)' },
  { code: 'pt-MO', name: 'Portuguese (Macao)' },
  { code: 'pt-MZ', name: 'Portuguese (Mozambique)' },
  { code: 'pt-PT', name: 'Portuguese (Portugal)' },
  { code: 'pt-ST', name: 'Portuguese (São Tomé & Príncipe)' },
  { code: 'pt-TL', name: 'Portuguese (Timor-Leste)' },
  { code: 'qu-BO', name: 'Quechua (Bolivia)' },
  { code: 'qu-EC', name: 'Quechua (Ecuador)' },
  { code: 'qu-PE', name: 'Quechua (Peru)' },
  { code: 'raj-IN', name: 'Rajasthani (India)' },
  { code: 'raj-IN-u-nu-latn', name: 'Rajasthani (India, Western Digits)' },
  { code: 'rm-CH', name: 'Romansh (Switzerland)' },
  { code: 'rn-BI', name: 'Rundi (Burundi)' },
  { code: 'ro-MD', name: 'Romanian (Moldova)' },
  { code: 'ro-RO', name: 'Romanian (Romania)' },
  { code: 'rof-TZ', name: 'Rombo (Tanzania)' },
  { code: 'ru-BY', name: 'Russian (Belarus)' },
  { code: 'ru-KG', name: 'Russian (Kyrgyzstan)' },
  { code: 'ru-KZ', name: 'Russian (Kazakhstan)' },
  { code: 'ru-MD', name: 'Russian (Moldova)' },
  { code: 'ru-RU', name: 'Russian (Russia)' },
  { code: 'ru-UA', name: 'Russian (Ukraine)' },
  { code: 'rw-RW', name: 'Kinyarwanda (Rwanda)' },
  { code: 'rwk-TZ', name: 'Rwa (Tanzania)' },
  { code: 'sa-IN', name: 'Sanskrit (India)' },
  { code: 'sa-IN-u-nu-latn', name: 'Sanskrit (India, Western Digits)' },
  { code: 'sah-RU', name: 'Yakut (Russia)' },
  { code: 'saq-KE', name: 'Samburu (Kenya)' },
  { code: 'sat-IN', name: 'Santali (India)' },
  { code: 'sat-IN-u-nu-latn', name: 'Santali (India, Western Digits)' },
  { code: 'sbp-TZ', name: 'Sangu (Tanzania)' },
  { code: 'sc-IT', name: 'Sardinian (Italy)' },
  { code: 'sd-Arab-PK', name: 'Sindhi (Arabic, Pakistan)' },
  {
    code: 'sd-Arab-PK-u-nu-latn',
    name: 'Sindhi (Arabic, Pakistan, Western Digits)',
  },
  { code: 'sd-Deva-IN', name: 'Sindhi (Devanagari, India)' },
  { code: 'se-FI', name: 'Northern Sami (Finland)' },
  { code: 'se-NO', name: 'Northern Sami (Norway)' },
  { code: 'se-SE', name: 'Northern Sami (Sweden)' },
  { code: 'seh-MZ', name: 'Sena (Mozambique)' },
  { code: 'ses-ML', name: 'Koyraboro Senni (Mali)' },
  { code: 'sg-CF', name: 'Sango (Central African Republic)' },
  { code: 'si-LK', name: 'Sinhala (Sri Lanka)' },
  { code: 'sk-SK', name: 'Slovak (Slovakia)' },
  { code: 'sl-SI', name: 'Slovenian (Slovenia)' },
  { code: 'smn-FI', name: 'Inari Sami (Finland)' },
  { code: 'sn-ZW', name: 'Shona (Zimbabwe)' },
  { code: 'so-DJ', name: 'Somali (Djibouti)' },
  { code: 'so-ET', name: 'Somali (Ethiopia)' },
  { code: 'so-KE', name: 'Somali (Kenya)' },
  { code: 'so-SO', name: 'Somali (Somalia)' },
  { code: 'sq-AL', name: 'Albanian (Albania)' },
  { code: 'sq-MK', name: 'Albanian (North Macedonia)' },
  { code: 'sq-XK', name: 'Albanian (Kosovo)' },
  { code: 'sr-Cyrl-BA', name: 'Serbian (Cyrillic, Bosnia & Herzegovina)' },
  { code: 'sr-Cyrl-ME', name: 'Serbian (Cyrillic, Montenegro)' },
  { code: 'sr-Cyrl-RS', name: 'Serbian (Cyrillic, Serbia)' },
  { code: 'sr-Cyrl-XK', name: 'Serbian (Cyrillic, Kosovo)' },
  { code: 'sr-Latn-BA', name: 'Serbian (Latin, Bosnia & Herzegovina)' },
  { code: 'sr-Latn-ME', name: 'Serbian (Latin, Montenegro)' },
  { code: 'sr-Latn-RS', name: 'Serbian (Latin, Serbia)' },
  { code: 'sr-Latn-XK', name: 'Serbian (Latin, Kosovo)' },
  { code: 'su-ID', name: 'Sundanese (Indonesia)' },
  { code: 'sv-AX', name: 'Swedish (Åland Islands)' },
  { code: 'sv-FI', name: 'Swedish (Finland)' },
  { code: 'sv-SE', name: 'Swedish (Sweden)' },
  { code: 'sw-CD', name: 'Swahili (Congo - Kinshasa)' },
  { code: 'sw-KE', name: 'Swahili (Kenya)' },
  { code: 'sw-TZ', name: 'Swahili (Tanzania)' },
  { code: 'sw-UG', name: 'Swahili (Uganda)' },
  { code: 'syr-IQ', name: 'Syriac (Iraq)' },
  { code: 'syr-SY', name: 'Syriac (Syria)' },
  { code: 'szl-PL', name: 'Silesian (Poland)' },
  { code: 'ta-IN', name: 'Tamil (India)' },
  { code: 'ta-LK', name: 'Tamil (Sri Lanka)' },
  { code: 'ta-MY', name: 'Tamil (Malaysia)' },
  { code: 'ta-SG', name: 'Tamil (Singapore)' },
  { code: 'te-IN', name: 'Telugu (India)' },
  { code: 'teo-KE', name: 'Teso (Kenya)' },
  { code: 'teo-UG', name: 'Teso (Uganda)' },
  { code: 'tg-TJ', name: 'Tajik (Tajikistan)' },
  { code: 'th-TH', name: 'Thai (Thailand)' },
  { code: 'ti-ER', name: 'Tigrinya (Eritrea)' },
  { code: 'ti-ET', name: 'Tigrinya (Ethiopia)' },
  { code: 'tk-TM', name: 'Turkmen (Turkmenistan)' },
  { code: 'to-TO', name: 'Tongan (Tonga)' },
  { code: 'tr-CY', name: 'Turkish (Cyprus)' },
  { code: 'tr-TR', name: 'Turkish (Türkiye)' },
  { code: 'tt-RU', name: 'Tatar (Russia)' },
  { code: 'twq-NE', name: 'Tasawaq (Niger)' },
  { code: 'tzm-MA', name: 'Central Atlas Tamazight (Morocco)' },
  { code: 'ug-CN', name: 'Uyghur (China)' },
  { code: 'uk-UA', name: 'Ukrainian (Ukraine)' },
  { code: 'ur-IN', name: 'Urdu (India)' },
  { code: 'ur-IN-u-nu-latn', name: 'Urdu (India, Western Digits)' },
  { code: 'ur-PK', name: 'Urdu (Pakistan)' },
  {
    code: 'ur-PK-u-nu-arabext',
    name: 'Urdu (Pakistan, Extended Arabic-Indic Digits)',
  },
  { code: 'uz-Arab-AF', name: 'Uzbek (Arabic, Afghanistan)' },
  {
    code: 'uz-Arab-AF-u-nu-latn',
    name: 'Uzbek (Arabic, Afghanistan, Western Digits)',
  },
  { code: 'uz-Cyrl-UZ', name: 'Uzbek (Cyrillic, Uzbekistan)' },
  { code: 'uz-Latn-UZ', name: 'Uzbek (Latin, Uzbekistan)' },
  { code: 'vec-IT', name: 'Venetian (Italy)' },
  { code: 'vi-VN', name: 'Vietnamese (Vietnam)' },
  { code: 'vmw-MZ', name: 'Makhuwa (Mozambique)' },
  { code: 'vun-TZ', name: 'Vunjo (Tanzania)' },
  { code: 'wae-CH', name: 'Walser (Switzerland)' },
  { code: 'wo-SN', name: 'Wolof (Senegal)' },
  { code: 'xh-ZA', name: 'Xhosa (South Africa)' },
  { code: 'xnr-IN', name: 'Kangri (India)' },
  { code: 'xog-UG', name: 'Soga (Uganda)' },
  { code: 'yav-CM', name: 'Yangben (Cameroon)' },
  { code: 'yo-BJ', name: 'Yoruba (Benin)' },
  { code: 'yo-NG', name: 'Yoruba (Nigeria)' },
  { code: 'yrl-BR', name: 'Nheengatu (Brazil)' },
  { code: 'yrl-CO', name: 'Nheengatu (Colombia)' },
  { code: 'yrl-VE', name: 'Nheengatu (Venezuela)' },
  { code: 'yue-Hans-CN', name: 'Cantonese (Simplified, China)' },
  { code: 'yue-Hant-HK', name: 'Cantonese (Traditional, Hong Kong)' },
  { code: 'za-CN', name: 'Zhuang (China)' },
  { code: 'zgh-MA', name: 'Standard Moroccan Tamazight (Morocco)' },
  { code: 'zh-Hans-CN', name: 'Chinese (Simplified, China)' },
  { code: 'zh-Hans-HK', name: 'Chinese (Simplified, Hong Kong)' },
  { code: 'zh-Hans-MO', name: 'Chinese (Simplified, Macao)' },
  { code: 'zh-Hans-SG', name: 'Chinese (Simplified, Singapore)' },
  { code: 'zh-Hant-HK', name: 'Chinese (Traditional, Hong Kong)' },
  { code: 'zh-Hant-MO', name: 'Chinese (Traditional, Macao)' },
  { code: 'zh-Hant-TW', name: 'Chinese (Traditional, Taiwan)' },
  { code: 'zu-ZA', name: 'Zulu (South Africa)' },
];

export const getLanguageByCodeFrom = (
  languages: readonly AndroidLanguage[],
  code: string,
): AndroidLanguage | undefined => {
  return languages.find((lang) => lang.code === code);
};

export const moveLanguageToFront = (
  languages: readonly AndroidLanguage[],
  code: string,
): AndroidLanguage[] => {
  const index = languages.findIndex((lang) => lang.code === code);
  if (index <= 0) {
    return Array.from(languages);
  }

  const reordered = Array.from(languages);
  const [language] = reordered.splice(index, 1);
  if (language) {
    reordered.unshift(language);
  }
  return reordered;
};

export const getLanguageByCode = (
  code: string,
): AndroidLanguage | undefined => {
  return getLanguageByCodeFrom(androidLanguages, code);
};

const languageCodePattern = /^[a-z]{2,3}(-[A-Z]{2})?$/;
const basicLanguagePattern = /^[a-z]{2,3}$/i;

const getLanguagePart = (locale: string): string => {
  return locale.toLowerCase().split('-')[0] ?? '';
};

type LocaleParts = {
  region?: string;
  script?: string;
};

const getMaximizedLocaleParts = (locale: string): LocaleParts | null => {
  try {
    const maximized = new Intl.Locale(locale).maximize();
    return {
      region: maximized.region,
      script: maximized.script,
    };
  } catch {
    return null;
  }
};

const hasSameLikelyLocale = (
  languageParts: LocaleParts,
  inputParts: LocaleParts,
): boolean => {
  return (
    Boolean(inputParts.region) &&
    languageParts.region === inputParts.region &&
    languageParts.script === inputParts.script
  );
};

const resolveFallbackAndroidLocale = (
  languages: readonly AndroidLanguage[],
  input: string,
  defaultLocale: string,
): string | null => {
  if (!languageCodePattern.test(input) && !basicLanguagePattern.test(input)) {
    return null;
  }

  const inputLanguagePart = getLanguagePart(input);
  const matchingLanguages = languages.flatMap((language) => {
    if (getLanguagePart(language.code) !== inputLanguagePart) {
      return [];
    }

    const parts = getMaximizedLocaleParts(language.code);
    return parts ? [{ language, parts }] : [];
  });
  if (matchingLanguages.length === 0) {
    return null;
  }

  const inputParts = getMaximizedLocaleParts(input);
  if (!inputParts) {
    return null;
  }

  const defaultMatch = matchingLanguages.find(({ language }) => {
    return language.code === defaultLocale;
  });
  if (defaultMatch && hasSameLikelyLocale(defaultMatch.parts, inputParts)) {
    return defaultMatch.language.code;
  }

  return (
    matchingLanguages.find(({ parts }) => {
      return hasSameLikelyLocale(parts, inputParts);
    })?.language.code ??
    matchingLanguages.find(({ parts }) => {
      return Boolean(inputParts.region) && parts.region === inputParts.region;
    })?.language.code ??
    matchingLanguages.find(({ parts }) => {
      return Boolean(inputParts.script) && parts.script === inputParts.script;
    })?.language.code ??
    null
  );
};

export const resolveToAndroidLocaleFrom = (
  languages: readonly AndroidLanguage[],
  input: string,
  defaultLocale: string = 'en-US',
  onError?: (error: unknown) => void,
): string | null => {
  if (!input || typeof input !== 'string') {
    return null;
  }

  const exactMatch = getLanguageByCodeFrom(languages, input);
  if (exactMatch) {
    return exactMatch.code;
  }

  try {
    return resolveFallbackAndroidLocale(languages, input, defaultLocale);
  } catch (error) {
    onError?.(error);
    return null;
  }
};

export function resolveToAndroidLocale(
  input: string,
  defaultLocale: string = 'en-US',
): string | null {
  return resolveToAndroidLocaleFrom(
    androidLanguages,
    input,
    defaultLocale,
    (error) => {
      console.error('Error matching language code:', error);
    },
  );
}
